import React, { useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { MdKeyboardArrowDown } from "react-icons/md";
import HomeSuccessstory from '../HomePageSettings/HomeSuccessstory'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';


import Homepagetrending from './Homepagetrending';
import { HomeExplorehot } from './HomeExplorehot';
import { Homebanner } from './Homebanner';



 export const Home = () => {

  const [showBanner, setShowBanner] = useState(false);
  const [activeSection, setActiveSection] = useState("banner"); // default content section

  return (
    <div className=''>
    


      {/* Main Content */}
      <div className="">
        <div className="space-y-2">

          {/* Banner Header */}
     <div className="flex border border-gray-200 w-fit items-center gap-2 p-2">
        <span
          data-tooltip-id="sectionTooltip"
          data-tooltip-html={`
            <div class='tooltip-bubble'>
              <div class='tooltip-content'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
              </div>
              <div class='tooltip-tail'></div>
            </div>
          `}
          className="text-xl cursor-pointer"
        >
          <HiOutlineInformationCircle />
        </span>
        <h1>
          {activeSection === "banner" && "Banner"}
          {activeSection === "trending" && "Trending Products"}
          {activeSection === "Explore product with high demand / Hot enquiry" && "Explore product with high demand / Hot enquiry"}
          {activeSection === "Success Story" && "Success Story"}
        </h1>
        <h1
          className="cursor-pointer text-xl z-10"
          onClick={() => setShowBanner(!showBanner)}
        >
          <MdKeyboardArrowDown />
        </h1>
      </div>

      <Tooltip
        id="sectionTooltip"
        place="bottom"
        offset={10}
        className="!bg-transparent !p-0 !rounded-none ms-28 z-30"
      />


          {/* Expandable Floating Banner */}
          {showBanner && (
  <div className="absolute  border border-gray-400 w-[30%] shadow-md space-y-2 bg-white p-2 z-20">
    <div
      className="cursor-pointer hover:bg-gray-100 p-2 rounded"
      onClick={() => {
        setActiveSection("banner");
        setShowBanner(false); // 👈 auto-close
      }}
    >
      Banner
    </div>
    <div
      className="cursor-pointer hover:bg-gray-100 p-2 rounded"
      onClick={() => {
        setActiveSection("trending");
        setShowBanner(false); // 👈 auto-close
      }}
    >
      Trending Products
    </div>
    <div
      className="cursor-pointer hover:bg-gray-100 p-2 rounded"
      onClick={() => {
        setActiveSection("Explore product with high demand / Hot enquiry");
        setShowBanner(false); // 👈 auto-close
      }}
    >
      Explore product with high demand / Hot enquiry
    </div>

     <div
      className="cursor-pointer hover:bg-gray-100 p-2 rounded"
      onClick={() => {
        setActiveSection("Success Story");
        setShowBanner(false); // 👈 auto-close
      }}
    >
      Success Story
    </div>
  </div>
)}


          {/* Conditional Content */}
          <div className="mt-10">
           
            {activeSection === "banner" && <Homebanner/>}
         {activeSection === "trending" && <Homepagetrending />} 
            {activeSection === "Explore product with high demand / Hot enquiry" && <HomeExplorehot/>}
            {activeSection === "Success Story" && <HomeSuccessstory/>}
          </div>

        </div>
      </div>
      
    </div>
  );
};




